import { render, staticRenderFns } from "./FinalCard.vue?vue&type=template&id=1a160bf8&"
import script from "./FinalCard.vue?vue&type=script&lang=js&"
export * from "./FinalCard.vue?vue&type=script&lang=js&"
import style0 from "./FinalCard.vue?vue&type=style&index=0&id=1a160bf8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports